import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import theme from './common/theme';
import { useLocalization } from './common/components/LocalizationProvider';

const cache = {
  ltr: createCache({
    key: 'muiltr',
    stylisPlugins: [prefixer],
  }),
  rtl: createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
  }),
};

const AppThemeProvider = ({ children }) => {
  const server = useSelector((state) => state.session.server);
  const revenda = useSelector((state) => state.session.revenda);
  const { direction } = useLocalization();

  // Dark mode controlado pelo servidor com fallback para true (padrão premium)
  // Prioridade: server.attributes.darkMode > true (padrão dark)
  // Se servidor definir darkMode = false → Light mode
  // Se servidor definir darkMode = true → Dark mode
  // Se não definir → Dark mode (padrão premium - indústria: Samsara, Fleetio, etc.)
  const serverDarkMode = server?.attributes?.darkMode;
  const darkMode = serverDarkMode !== undefined ? serverDarkMode : true;

  const themeInstance = theme(server, revenda, darkMode, direction);

  // 2ECOMP: Sync theme mode to body for CSS-only components (map controls)
  // Also adds class for lightModeOverrides.css
  useEffect(() => {
    const body = document.body;
    body.setAttribute('data-theme', darkMode ? 'dark' : 'light');

    // Toggle body classes for CSS overrides
    if (darkMode) {
      body.classList.remove('light-mode');
      body.classList.add('dark-mode');
    } else {
      body.classList.remove('dark-mode');
      body.classList.add('light-mode');
    }
  }, [darkMode]);

  return (
    <CacheProvider value={cache[direction]}>
      <ThemeProvider theme={themeInstance}>
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
};

export default AppThemeProvider;
